import {emotionStyled, tokens} from '@packages/utilities/styled';
import {Card} from '../../Card';
import {MODAL_CARD_MAX_HEIGHT_VAR} from '../constants';

import {HEADER_HANDLE, mergeCancelSelectors} from '../ModalDraggableWrapper';

export const ModalCardView = emotionStyled(Card)(
  {
    color: '$textPrimary',
    display: 'flex',
    minWidth: 300,
    flexDirection: 'column',
    /**
     * This local var is set in the `ModalContent` component.
     *
     * If `isCentered` and `shouldAnchorModalTop` are true, then the `maxHeight` will be set to the correct value in `ModalContent`.
     *
     * Otherwise, the `maxHeight` will be set to 90vh.
     */
    maxHeight: `var(${MODAL_CARD_MAX_HEIGHT_VAR}, 90vh)`,
    maxWidth: 'calc(100vw - 20px)',
    width: '90vw',
  },
  {
    componentName: 'Modal',
    variants: {
      isCentered: {
        true: {
          margin: 'auto',
        },
      },
      shouldRenderDragHandles: {
        true: {
          // Grab cursor on header (exclude back button)
          [HEADER_HANDLE]: {
            cursor: 'grab',
          },
          [mergeCancelSelectors()]: {
            cursor: tokens.ui.activeCursor,
          },
          /**
           * React draggable injects the react-draggable-dragging class name.
           * This happens within ModalDraggableWrapper.
           */
          [`&.react-draggable-dragging *`]: {
            cursor: 'grabbing',
          },
        },
      },
      isFullHeight: {
        true: {
          marginBottom: 0,
          marginTop: 0,
          minHeight: '100vh',
          /**
           * Ensures that the height is maximized correctly on non-desktop
           * devices.
           *
           * @see https://css-tricks.com/css-fix-for-100vh-in-mobile-webkit/
           */
          '@supports (height: stretch)': {
            minHeight: 'stretch',
          },
        },
      },
      modalSize: {
        small: {
          width: 360,
        },
        medium: {
          width: 480,
        },
        large: {
          width: 600,
        },
        'x-large': {
          width: 720,
        },
      },
      scrollBehavior: {
        inside: {},
        outside: {
          maxHeight: 'initial',
        },
      },
    },
  }
);
